import { withErrorBoundary } from "@sentry/nextjs";
import { FC } from "react";
import styled from "styled-components";
import { LegacyImage, Link } from "components";
import { MapMark } from "icons";
import { Carousel6Content } from "types/graphql/generated";

interface Props {
  className?: string;
  content: Carousel6Content["carousel6Options"][0];
}

const Card: FC<Props> = withErrorBoundary(
  ({
    className = "",
    content: {
      employeesCount,
      openingDate,
      addressLabel,
      addressLink,
      image: {
        data: { image },
      },
    },
  }) => {
    return (
      <StyledCard className={className}>
        <div className="Carousel6Card__cardContainer">
          {employeesCount && openingDate && (
            <div className="Carousel6Card__text">
              <span className="Carousel6Card__officeInfo Color_eucalyptus80 Font_14_20_600">{employeesCount}</span>
              <span className="Carousel6Card__officeInfo Color_eucalyptus80 Font_14_20_600">{openingDate}</span>
            </div>
          )}
          <LegacyImage {...image} layout="fill" className="Carousel6Card__image" objectFit="cover" />
        </div>
        <Link href={addressLink} className="Carousel6Card__addressLink Color_eucalyptus80 Font_18_26_600">
          <MapMark className="Carousel6Card__mapMarkIcon" />
          <p className="Carousel6Card__cardDescription">{addressLabel}</p>
        </Link>
      </StyledCard>
    );
  },
  {}
);

const StyledCard = styled.div`
  height: 100%;
  padding: 60px;
  background-color: ${({ theme }) => theme.colors.coral["05"]};

  .Carousel6Card__cardContainer {
    position: relative;
  }

  .Carousel6Card__text {
    position: absolute;
    z-index: 1;
    right: 16px;
    top: 16px;
    display: flex;
    flex-direction: column;
    place-items: flex-end;

    .Carousel6Card__officeInfo {
      padding: 2px 10px;
      background-color: ${({ theme }) => theme.colors.fog["10"]};
      border-radius: 50px;

      &:not(:first-child) {
        margin-top: 8px;
      }
    }
  }

  .Carousel6Card__image {
    position: relative;
    max-width: 604px;
    width: 100%;
    height: 328px;
    border-radius: 8px;
    overflow: hidden;
  }

  .Carousel6Card__addressLink {
    display: flex;
    margin-top: 16px;
    height: 100%;
  }

  .Carousel6Card__mapMarkIcon {
    width: 24px;
    height: 24px;
    flex-shrink: 0;
  }

  .Carousel6Card__cardDescription {
    margin-left: 8px;
  }

  @media (max-width: ${({ theme }) => `${theme.breakpoints.lg}px`}) {
    padding: 32px;
  }

  @media (max-width: 660px) {
    padding: 0;

    .Carousel6Card__image {
      height: 240px;
      border-radius: 0;
    }

    .Carousel6Card__addressLink {
      padding: 16px;
      margin-top: unset;
      background-color: ${({ theme }) => theme.colors.coral["05"]};
      width: 100%;
      height: 100%;
    }
  }
`;

export { Card };
